import React from 'react'
//import styles from './styles.module.css'
import { Provider } from 'react-redux';
import ReduxStore from './store';

import EncargadoRecupero from './components/encargado-recupero';
import RecuperoEntreCompanias from './components/recupero-cias';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
//import RouterAPP from './routes'; 
import apiInterceptor from './api/api-interceptor';
import RouterAPP from './routes';
import RecuperoDirecto from './components/recupero-directo';
import RecuperoEntreCIAS from './components/recupero-entre-cias';
apiInterceptor();

export const EncargadoRecuperoComponent = () => {
  return (
    <Provider store={ReduxStore()}>
      <EncargadoRecupero />    
      {/* <RouterAPP/> */}
    </Provider>
  )
}
export const RecuperoEntreCompaniasComponent = () => {
  return (
    <Provider store={ReduxStore()}>    
      <RecuperoEntreCompanias />
      {/*<RouterAPP/> */}
    </Provider>
  )
}
export const RecuperoDirectoComponent = () => {
  return (
    <Provider store={ReduxStore()}>    
      <RecuperoDirecto />
      {/* <RouterAPP/> */}
    </Provider>
  )
}
export const RecuperoEntreCIASComponent = () => {
  return (
    <Provider store={ReduxStore()}>    
      <RecuperoEntreCIAS />
      {/* <RouterAPP/> */}
    </Provider>
  )
}